<template>
  <div class="home">
    <v-img
      dark
      max-height="500px"
      style="filter: grayscale(80%)"
      src="https://images.unsplash.com/photo-1494587351196-bbf5f29cff42?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1351&q=80"
    >
      <v-layout fill-height align-center>
        <v-container>
          <v-row align="center" justify="center" class="white--text">
            <v-col cols="12">
              <div class="display-2 font-weight-bold">Welcome to my page.</div>
              <div class="headline">I make applications.</div>
            </v-col>
          </v-row>
        </v-container>
      </v-layout>
    </v-img>
    <v-container class="mt-5">
      <v-layout wrap>
        <v-flex xs12>
          <div class="display-1 font-weight-bold" id="about">About me</div>
        </v-flex>
        <v-flex xs12 mt-5>
          <div class="body-1">{{aboutText}}</div>
        </v-flex>
      </v-layout>
      <br>
      <hr>
      <v-layout wrap my-5>
        <v-flex xs12>
          <div class="display-1 font-weight-bold" id="portfolio">My Work</div>
        </v-flex>
        <v-flex xs12 class="mt-5">
          <v-layout wrap>
            <template v-for="(app, i) in apps">
              <v-flex :key="i" xs12 sm6 md4>
                <p-portfolio-app :app="app" />
              </v-flex>
            </template>
          </v-layout>
        </v-flex>
      </v-layout>
      <hr>
      <v-layout wrap my-5>
        <v-flex xs12 mb-5>
          <div class="display-1 font-weight-bold" id="contact">Contact Me</div>
        </v-flex>
        <template v-for="(contact, i) in contactLinks">
          <v-flex sm6 md4 xs12 :key="i">
            <p-contact-info :contact="contact" />
          </v-flex>
        </template>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import PPortfolioApp from "@/components/PPortfolioApp.vue";
import PContactInfo from "@/components/PContactInfo.vue";

export default {
  name: "home",
  components: {
    PPortfolioApp,
    PContactInfo
  },
  data() {
    return {
      aboutText:
        "My name is Tristan Simpson. I'm a Frontend Developer with a passion to create precision interfaces & experiences. I consider myself a life-time learner, and spend most of my time researching some form of technology or another. My hobbies outside of work consist of Hiking, Cooking healthy food and Traveling with my girlfriend.",
      apps: [
        {
          name: "TwitVue",
          price: "OPEN-SOURCE",
          logo: "logo-dark-twitter-png-20.png",
          platforms: [
            {
              name: "Web",
              icon: "mdi-web",
              link: "https://github.com/saucebyt/TwitVue"
            }
          ],
          description:
            "This is a Responsive Mobile App created using Vue.js, Cordova and the Twitter API.",
          technologies: [
            {
              name: "Vue.js",
              icon: "mdi-vuejs",
              link: ""
            },
            {
              name: "Cordova",
              icon: "mdi-cordova",
              link: ""
            },
            {
              name: "Twitter API",
              icon: "mdi-api",
              link: ""
            }
          ],
          code: {
            name: "github",
            icon: "mdi-github-circle",
            link: ""
          }
        },
        {
          name: "Vue-Do",
          price: "OPEN-SOURCE",
          logo: "github.png",
          platforms: [
            {
              name: "Web",
              icon: "mdi-web",
              link: "http://vue-do.surge.sh/"
            }
          ],
          description:
            "This is a Simple SPA created with Vue.js. It works as a 'To-Do' list.",
          technologies: [
            {
              name: "JavaScript",
              icon: "mdi-language-javascript",
              link: ""
            },
            {
              name: "Vue.js",
              icon: "mdi-vuejs",
              link: ""
            },
          ],
          code: {
            name: "github",
            icon: "mdi-github-circle",
            link: ""
          }
        },
        {
          name: "Vue-Chat",
          price: "OPEN-SOURCE",
          logo: "chat.png",
          platforms: [
            {
              name: "Web",
              icon: "mdi-web",
              link: "https://github.com/saucebyt/Vue-Chat"
            }
          ],
          description:
            "This app has the basic functionality of any chatroom app, however this one is built with Vue.js and PhoneGap in order to run on mobile devices.",
          technologies: [
            {
              name: "JavaScript",
              icon: "mdi-language-javascript",
              link: ""
            },
            {
              name: "Vue.js",
              icon: "mdi-vuejs",
              link: ""
            },
            {
              name: "Cordova",
              icon: "mdi-cordova",
              link: ""
            },
            {
              name: "Firebase",
              icon: "mdi-firebase",
              link: ""
            }
          ],
          code: {
            name: "github",
            icon: "mdi-github-circle",
            link: ""
          }
        },
      ],
      contactLinks: [
        {
          name: "Email",
          value: "tasimpson.hd@gmail.com",
          link: "mailto:tasimpson.hd@gmail.com",
          icon: "mdi-email"
        },
        {
          name: "LinkedIn",
          value: "Tristan Simpson",
          link: "https://www.linkedin.com/in/tristan-simpson/",
          icon: "mdi-linkedin"
        },
        {
          name: "Github",
          value: "saucebyt",
          link: "https://github.com/saucebyt/",
          icon: "mdi-github"
        }
      ]
    };
  }
};
</script>
